// extracted by mini-css-extract-plugin
export default {"ns_box_base_combo_select":"NSBoxBaseCombo_ns_box_base_combo_select__moaGu"};